export const getProductPromotions = ({ promotions = []} = {}) =>
  promotions
    .filter(({ isUserAppliedPromotion } = {}) => !isUserAppliedPromotion)
